export const GetWeek = function (d) {
    var target = new Date(d.valueOf());
    var dayNr = (d.getDay() + 6) % 7;
    target.setDate(target.getDate() - dayNr + 5);
    var firstThursday = target.valueOf();
    var yearStart = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
    target.setMonth(0, 1);
    if (target.getDay() != 4) {
        target.setMonth(0, 1 + ((4 - target.getDay()) + 7) % 7);
    }

    return (1 + Math.ceil((firstThursday - target) / 604800000));
}

export const timeConverter = (val) => {
    return val.split('.')[0] + 'Z'
}